import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LanguageService } from '../_services/language.service';
import { GlobalService } from '../_services/global.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
    constructor(
         public globalService : GlobalService,
         public lang:LanguageService,
    ) {};

    model: any[] = [];

   
    ngOnInit() {
        let userRole=this.globalService.getUser().role;

        let model: any[] = [
            {
                label: this.lang.el('Preventivi'),
                icon: 'pi pi-home',
                items: [
                    {
                        label: this.lang.el('Preventivi'),
                        icon: 'pi pi-fw pi-money-bill',
                        routerLink: ['/opportunities']
                    }
                ]
            },
        ];
       
        if(userRole=='AMMINISTRATORE' || ['m.fusaro', 'f.pistininzi', 'ca.bianchi', 'cr.bianchi', 'e.auguadro'].includes(this.globalService.getUser().username)){
            model.push(    
                {
                label: 'ADMIN',
                icon: 'pi pi-home',
                items: [
                    {
                        label: this.lang.el('Utenti'),
                        icon: 'pi pi-fw pi-user',
                        routerLink: ['/users']
                    },
                    {
                        label: this.lang.el('Modelli offerte'),
                        icon: 'pi pi-fw pi-file-word',
                        routerLink: ['/doctemplates']
                    },
                    {
                        label: this.lang.el('Tickets'),
                        icon: 'pi pi-fw pi-bell',
                        routerLink: ['/tickets']
                    },
                    {
                        label: this.lang.el('Traduzioni'),
                        icon: 'pi pi-fw pi-globe',
                        routerLink: ['/translations']
                    },
                    
                    ]
                }
            );
        }
        this.model =model;
       
    }
}
